import React from 'react';
import styled from "styled-components";
import Icon from "@atoms/icon";
import ArrowRightIcon from '@icons/arrow-right.svg';
import ConvertPixelToRem from "@helpers/convert.rem";

function DropdownHeader({label, setShow}) {
    return (
        <Header className="selection-dropdown-header">
            <Title>{label}</Title>
            <Back onClick={() => setShow(false)}>
                <ArrowRightIcon strokeWidth="2" with={24}/>
            </Back>
        </Header>
    )
}

export default React.memo(DropdownHeader);
// styles

const Back = styled(Icon)`
    cursor: pointer;
    width: 16px;
    max-width: 16px;
`;

const Title = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: ${ConvertPixelToRem(18)};
    font-weight: bold;
    line-height: 1.67;
    text-align: center;
    color: ${props => props.theme.black};
`;

export const Header = styled.div`
    display: none;
    height: 56px;
    min-height: 56px;
    max-height: 56px;
    justify-content: flex-start;
    position: relative;
    background: #fff;
    cursor: default;
    padding: 0 24px;
    border-radius: 16px 16px 0 0;
    
    @media only screen and (max-width: ${props => props.theme.screenSmMax}) {
        display: flex;
        align-items: center;
        
    }
    
    @media only screen and (max-width: ${props => props.theme.screenXsMax}) {
        padding: 0 24px;
    }
`;